import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemLocationSetting\GetItemLocationSetting::__invoke
* @see app/Http/Controllers/ItemLocationSetting/GetItemLocationSetting.php
* @route '/api/item-location-setting'
*/
const GetItemLocationSetting = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemLocationSetting.url(options),
    method: 'get',
})

GetItemLocationSetting.definition = {
    methods: ["get","head"],
    url: '/api/item-location-setting',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ItemLocationSetting\GetItemLocationSetting::__invoke
* @see app/Http/Controllers/ItemLocationSetting/GetItemLocationSetting.php
* @route '/api/item-location-setting'
*/
GetItemLocationSetting.url = (options?: RouteQueryOptions) => {
    return GetItemLocationSetting.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemLocationSetting\GetItemLocationSetting::__invoke
* @see app/Http/Controllers/ItemLocationSetting/GetItemLocationSetting.php
* @route '/api/item-location-setting'
*/
GetItemLocationSetting.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemLocationSetting.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ItemLocationSetting\GetItemLocationSetting::__invoke
* @see app/Http/Controllers/ItemLocationSetting/GetItemLocationSetting.php
* @route '/api/item-location-setting'
*/
GetItemLocationSetting.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemLocationSetting.url(options),
    method: 'head',
})

export default GetItemLocationSetting